module.exports = __webpack_public_path__ + "static/media/users-crown.ea8286fa.svg";